module.exports = __webpack_public_path__ + "media/components/lesson1/statics/sendButton-3bd69b8830776710b55175a3e922701d.png";